import { ViewpointFormattingProps } from './viewpointFormattingTypes';

export const getFormattingRulesCount = (state: ViewpointFormattingProps) => ({
  conditionalFormattingRulesCount:
    state.conditionalFormatting.formattingRules.length,
  labelFormattingRulesCount: state.multiLabelFormatting.labelFormatting.length,
});
